import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "view_list",
  "use": "view_list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"view_list\"><path d=\"M10 17h6c1.1 0 2-.9 2-2h-8zm0-8h6c1.1 0 2-.9 2-2h-8zm8.48-7H5.52C3.58 2 2 3.58 2 5.52v12.97c0 1.94 1.58 3.52 3.52 3.52h12.97c1.94 0 3.52-1.58 3.52-3.52V5.52A3.54 3.54 0 0 0 18.48 2M6 20h-.48C4.68 20 4 19.32 4 18.48V5.52C4 4.68 4.68 4 5.52 4H6zm14-1.52c0 .84-.68 1.52-1.52 1.52H8V4h10.48c.84 0 1.52.68 1.52 1.52zM10 13h6c1.1 0 2-.9 2-2h-8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol